export const isLoading = state => state.adminReducer.qualification.isLoading

export const isSuccess = state => state.adminReducer.qualification.isSuccess

export const qualification = state => state.adminReducer.qualification.qualification

export const options = state => state.adminReducer.qualification.options

export const permissions = state => state.adminReducer.qualification.permissions
